"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlaylistController = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*
 * Copyright, AlpineReplay, Inc. 2021. All rights reserved.
 * Author: Brian Bal
 */
var ControllerID = 90;

var PlaylistController = /*#__PURE__*/function () {
  function PlaylistController() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, PlaylistController);

    this._initialMomentId = opts.initialId ? opts.initialId : null;
    this._currentIndex = 0;
    this._moments = [];
    this.id = opts.id || ControllerID++;
    this.onNext = opts.onNext ? opts.onNext : null;
    this.onPrev = opts.onPrev ? opts.onPrev : null;
  }

  _createClass(PlaylistController, [{
    key: "destroy",
    value: function destroy() {
      var index = PlaylistController._instances.indexOf(this);

      if (index) {
        PlaylistController._instances.splice(index, 1);
      }
    }
  }, {
    key: "moments",
    get: function get() {
      if (!this._moments) {
        this._moments = [];
      }

      return this._moments;
    },
    set: function set(val) {
      if (val != null && Array.isArray(val)) {
        if (this._initialMomentId) {
          var index = null;

          for (var i = 0; i < val.length; i++) {
            if (val[i].game_clip_id === this._initialMomentId) {
              index = i;
              break;
            }
          }

          this._moments = val;
          this._currentIndex = index ? index : 0;
          this._initialMomentId = null;
        } else {
          this._currentIndex = 0;
        }
      }
    }
  }, {
    key: "nextItem",
    get: function get() {
      var item = null;
      var index = this._currentIndex + 1;

      if (index >= this.moments.length) {
        index = 0;
      }

      if (index < 0) {
        index = 0;
      }

      if (0 <= index && index < this.moments.length) {
        item = this.moments[index];
      }

      return item;
    }
  }, {
    key: "nextMoment",
    get: function get() {
      var item = this.nextItem;
      return item && item.moment ? item.moment : item;
    }
  }, {
    key: "prevItem",
    get: function get() {
      var item = null;
      var index = this._currentIndex - 1;

      if (index < 0) {
        index = this.moments.length - 1;
      }

      if (index >= this.moments.length) {
        index = this.moments.length - 1;
      }

      if (0 <= index && index < this.moments.length) {
        item = this.moments[index];
      }

      return item;
    }
  }, {
    key: "prevMoment",
    get: function get() {
      var item = this.prevItem;
      return item && item.moment ? item.moment : item;
    }
  }, {
    key: "currentItem",
    get: function get() {
      var item = null;

      if (this._currentIndex >= 0 && this.moments.length > this._currentIndex) {
        item = this.moments[this._currentIndex];
      }

      return item && item.moment ? item.moment : item;
    }
  }, {
    key: "currentMoment",
    get: function get() {
      var item = this.currentItem;
      return item && item.moment ? item.moment : item;
    }
    /*
     * Playlist controls
     */

  }, {
    key: "goToItem",
    value: function goToItem(id) {
      var _iterator = _createForOfIteratorHelper(this.moments.entries()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
              index = _step$value[0],
              moment = _step$value[1];

          if ( // eslint-disable-next-line eqeqeq
          moment.user_playlist_clip_id == id || // eslint-disable-next-line eqeqeq
          moment.game_clip_id == id) {
            if (this._currentIndex === index) {
              return false;
            } else {
              this._currentIndex = index;
              return true;
            }
          }

          if (moment.moment) {
            var m = moment.moment;

            if (m.game_clip_id == id) {
              if (this._currentIndex == index) {
                return false;
              } else {
                this._currentIndex = index;
                return true;
              }
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return false;
    }
  }, {
    key: "goToNext",
    value: function goToNext() {
      var item = this.nextItem;
      var nextIndex = this.moments.indexOf(item);
      this._currentIndex = nextIndex;

      if (this.onNext) {
        this.onNext(item);
      }
    }
  }, {
    key: "goToPrev",
    value: function goToPrev() {
      var item = this.prevItem;
      var prevIndex = this.moments.indexOf(item);
      this._currentIndex = prevIndex;

      if (this.onPrev) {
        this.onPrev(item);
      }
    }
  }], [{
    key: "getInstance",
    value: function getInstance() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var controller = this._instances.find(function (item) {
        return item.id === id;
      });

      if (!controller) {
        controller = new PlaylistController({
          id: id
        });

        this._instances.push(controller);
      }

      return controller;
    }
  }, {
    key: "findInstance",
    value: function findInstance() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var controller = this._instances.find(function (item) {
        return item.id === id;
      });

      if (!controller) {
        controller = null;
      }

      return controller;
    }
  }]);

  return PlaylistController;
}();

exports.PlaylistController = PlaylistController;

_defineProperty(PlaylistController, "_instances", []);